// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"MatchTabs_buttonsWrapper__Wu34B","active":"MatchTabs_active__2VNUq"};